import { render } from "./auth.layout.vue?vue&type=template&id=11331623"
const script = {}

import exportComponent from "/home/ubuntu/ciyc-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__